"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMapWithAdmin = exports.updateMapWithStaff = exports.updateMapWithRisk = exports.remove = exports.create = exports.findNumberToCreate = exports.update = exports.getContainCycle = exports.updateMaps = exports.getAll = exports.get = void 0;
var PRC_1 = require("@cck/common/dist/data/PRC");
var Config_1 = require("@cck/common/dist/utils/Config");
var lodash_1 = __importDefault(require("lodash"));
var TemplateUpdater = __importStar(require("../evaluation/TemplateUpdater"));
var firebase = __importStar(require("../firebase/fbase"));
var Admin = __importStar(require("../utils/Admin"));
var UpdateContainer_1 = __importStar(require("../utils/UpdateContainer"));
var CycleManager = __importStar(require("./CycleManager"));
var DepartmentManager = __importStar(require("./DepartmentManager"));
var ProcessManager = __importStar(require("./ProcessManager"));
var RCMUtils_1 = require("./RCMUtils");
var RiskManager = __importStar(require("./RiskManager"));
var StaffManager = __importStar(require("./StaffManager"));
var UPDATING_EXCEPTION_KEYS = [
    'type',
    'id',
    // 부서 연결은 updateMapWithStaff/updateMaps에서 관리한다.
    'departmentIds',
    'cycleIds',
    'cycleName',
    'cycleNumber',
    'categoryName',
    'categoryNumber',
    'subCategoryName',
    'subCategoryNumber',
    'processIds',
    'processCategoryName',
    'processCategoryNumber',
    'processCode',
    'processCycleName',
    'processCycleNumber',
    'processMappingCode',
    'processSubCategoryName',
    'processSubCategoryNumber',
    'riskIds',
    'riskName',
    'riskNumber'
];
function get(id) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = (_a = (0, Config_1.getControlClass)()).from;
                    return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.CONTROL_COLLECTION_NAME).doc(id).get()];
                case 1: return [2 /*return*/, _b.apply(_a, [(_c.sent()).data()])];
            }
        });
    });
}
exports.get = get;
function getAll() {
    return __awaiter(this, void 0, void 0, function () {
        var collectionData, controlClass;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.CONTROL_COLLECTION_NAME).get()];
                case 1:
                    collectionData = _a.sent();
                    controlClass = (0, Config_1.getControlClass)();
                    return [2 /*return*/, lodash_1.default.map(collectionData.docs, function (docData) { return controlClass.from(docData.data()); })];
            }
        });
    });
}
exports.getAll = getAll;
var updateMap = function (controlId, typeToIds) { return __awaiter(void 0, void 0, void 0, function () {
    var finalUpdateObject, controlObject, riskId, riskData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                finalUpdateObject = {};
                return [4 /*yield*/, get(controlId)];
            case 1:
                controlObject = _a.sent();
                lodash_1.default.forEach(['cycleIds', 'processIds', 'riskIds', 'staffIds', 'departmentIds'], function (targetKey) {
                    var newIds = (0, UpdateContainer_1.applyUpdateIds)(controlObject[targetKey], typeToIds === null || typeToIds === void 0 ? void 0 : typeToIds[targetKey]);
                    finalUpdateObject[targetKey] = newIds;
                    var headId = lodash_1.default.head(newIds) || '';
                    if (targetKey === 'processIds') {
                        finalUpdateObject.processCode = headId;
                    }
                    if (targetKey === 'staffIds' && headId !== '') {
                        finalUpdateObject.owner = headId;
                        // 수정 시 Template 과 관련된 내용은 Template 에서도 업데이트를 해줘야한다.
                        controlObject.owner = headId;
                    }
                    if (targetKey === 'departmentIds' && headId !== '') {
                        finalUpdateObject.department = headId;
                        // 수정 시 Template 과 관련된 내용은 Template 에서도 업데이트를 해줘야한다.
                        controlObject.department = headId;
                    }
                });
                if (!(finalUpdateObject.riskIds.length === 0)) return [3 /*break*/, 2];
                // CONTROL 은 하나의 RISK 만 가질 수 있기 때문에
                // CONTROL 에 연결된 RISK 가 없다면 연결된 PROCESS 도 존재하지 않아야 하는 것이 맞다.
                finalUpdateObject.riskName = '';
                finalUpdateObject.riskNumber = '';
                finalUpdateObject.processCode = '';
                finalUpdateObject.processIds = [];
                return [3 /*break*/, 4];
            case 2:
                if (!(finalUpdateObject.riskIds.length === 1)) return [3 /*break*/, 4];
                riskId = finalUpdateObject.riskIds[0];
                return [4 /*yield*/, RiskManager.get(riskId)];
            case 3:
                riskData = _a.sent();
                finalUpdateObject.riskName = riskData.name;
                finalUpdateObject.riskNumber = riskId;
                finalUpdateObject.processCode = riskData.processIds[0];
                finalUpdateObject.processIds = riskData.processIds;
                _a.label = 4;
            case 4:
                // 수정 시 Template 과 관련된 내용은 Template 에서도 업데이트를 해줘야한다.
                controlObject.riskName = finalUpdateObject.riskName;
                controlObject.riskNumber = finalUpdateObject.riskNumber;
                controlObject.processCode = finalUpdateObject.processCode;
                return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.CONTROL_COLLECTION_NAME).doc(controlId).update(finalUpdateObject)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var updateMaps = function (updateIdContainer) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(lodash_1.default.map(updateIdContainer.values(), function (updateIds, controlId) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, updateMap(controlId, updateIds)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.updateMaps = updateMaps;
var getContainCycle = function () { return __awaiter(void 0, void 0, void 0, function () {
    var cycleDataAll, controlDataAll, user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, CycleManager.getAll()];
            case 1:
                cycleDataAll = _a.sent();
                return [4 /*yield*/, getAll()];
            case 2:
                controlDataAll = _a.sent();
                return [4 /*yield*/, Admin.getOrCreateUser()];
            case 3:
                user = _a.sent();
                return [2 /*return*/, (0, lodash_1.default)(controlDataAll)
                        .map(function (control) {
                        var cycleId = control.cycleIds[0];
                        var relateCycleObject = lodash_1.default.find(cycleDataAll, { id: cycleId });
                        if (!relateCycleObject) {
                            return undefined;
                        }
                        if ((user.level === 'UPLOADER' || user.level === 'NORMAL') &&
                            user.id !== control.owner &&
                            user.id !== control.incharge) {
                            return undefined;
                        }
                        control.type = PRC_1.PRCType.control;
                        control.cycleNumber = relateCycleObject.cycleNumber;
                        control.cycleName = relateCycleObject.cycleName;
                        control.categoryNumber = relateCycleObject.categoryNumber;
                        control.categoryName = relateCycleObject.categoryName;
                        control.subCategoryNumber = relateCycleObject.subCategoryNumber;
                        control.subCategoryName = relateCycleObject.subCategoryName;
                        return control;
                    })
                        .compact()
                        .value()];
        }
    });
}); };
exports.getContainCycle = getContainCycle;
var update = function (newControlInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var newControl, controlId, docRef, controlData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newControl = Object.setPrototypeOf(lodash_1.default.cloneDeep(newControlInstance), Object.prototype);
                controlId = newControl.id;
                lodash_1.default.forEach(UPDATING_EXCEPTION_KEYS, function (exceptionKey) { return lodash_1.default.unset(newControl, exceptionKey); });
                docRef = firebase.dbService.collection(RCMUtils_1.CONTROL_COLLECTION_NAME).doc(controlId);
                return [4 /*yield*/, docRef.update(newControl)
                    // TODO: 평가 보고서
                    // CONTROL 의 내용을 바꾸면 해당 Template 을 업데이트 해야한다
                    // Template 과 관련된 모든 정보
                ];
            case 1:
                _a.sent();
                return [4 /*yield*/, get(controlId)];
            case 2:
                controlData = _a.sent();
                controlData.updateForOperationTemplate(newControlInstance);
                return [4 /*yield*/, TemplateUpdater.updateTemplate('operation', controlId, controlData)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.update = update;
var findNumberToCreate = function (processId) { return __awaiter(void 0, void 0, void 0, function () {
    var controlDataAll;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getAll()];
            case 1:
                controlDataAll = _a.sent();
                return [2 /*return*/, 'C' + (0, RCMUtils_1.getNewNumber)(processId, controlDataAll)];
        }
    });
}); };
exports.findNumberToCreate = findNumberToCreate;
var makeUpdateMapFromCreate = function (controlId, cycleId, processId, riskId) { return __awaiter(void 0, void 0, void 0, function () {
    var cycleUpdateMap, processUpdateMap, riskUpdateMap;
    return __generator(this, function (_a) {
        cycleUpdateMap = new UpdateContainer_1.default();
        cycleUpdateMap.add(cycleId, 'controlIds', controlId);
        processUpdateMap = new UpdateContainer_1.default();
        processUpdateMap.add(processId, 'controlIds', controlId);
        riskUpdateMap = new UpdateContainer_1.default();
        riskUpdateMap.add(riskId, 'controlIds', controlId);
        return [2 /*return*/, { cycleUpdateMap: cycleUpdateMap, processUpdateMap: processUpdateMap, riskUpdateMap: riskUpdateMap }];
    });
}); };
var create = function (controlId, newControlInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var newControl, cycleId, riskId, processId, cycleData, riskData, _a, cycleUpdateMap, processUpdateMap, riskUpdateMap, docRef;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                newControl = Object.setPrototypeOf(newControlInstance, Object.prototype);
                return [4 /*yield*/, (0, RCMUtils_1.isNotUniqueId)(controlId)];
            case 1:
                if (_b.sent()) {
                    throw new Error("Not unique id ".concat(controlId));
                }
                if (lodash_1.default.isEmpty(newControl.cycleIds) ||
                    lodash_1.default.isEmpty(newControl.processCode) ||
                    lodash_1.default.isEmpty(newControl.riskNumber)) {
                    throw new Error('Empty cycle id or process id or risk id');
                }
                cycleId = newControl.cycleIds[0];
                riskId = newControl.riskNumber;
                processId = newControl.processCode;
                return [4 /*yield*/, CycleManager.get(cycleId)];
            case 2:
                cycleData = _b.sent();
                return [4 /*yield*/, RiskManager.get(riskId)];
            case 3:
                riskData = _b.sent();
                return [4 /*yield*/, makeUpdateMapFromCreate(controlId, cycleId, processId, riskId)];
            case 4:
                _a = _b.sent(), cycleUpdateMap = _a.cycleUpdateMap, processUpdateMap = _a.processUpdateMap, riskUpdateMap = _a.riskUpdateMap;
                docRef = firebase.dbService.collection(RCMUtils_1.CONTROL_COLLECTION_NAME).doc(controlId);
                return [4 /*yield*/, docRef.set(__assign(__assign({}, newControl), { id: controlId, cycleNumber: cycleData.cycleNumber, cycleName: cycleData.cycleName, categoryNumber: cycleData.categoryNumber, categoryName: cycleData.categoryName, subCategoryNumber: cycleData.subCategoryNumber, subCategoryName: cycleData.subCategoryName, riskNumber: riskId, riskName: riskData.name, staffIds: [], departmentIds: [], cycleIds: [cycleId], processIds: [processId], processCode: processId, riskIds: [riskId] }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, CycleManager.updateMaps(cycleUpdateMap)];
            case 6:
                _b.sent();
                return [4 /*yield*/, ProcessManager.updateMaps(processUpdateMap)];
            case 7:
                _b.sent();
                return [4 /*yield*/, RiskManager.updateMaps(riskUpdateMap)];
            case 8:
                _b.sent();
                return [2 /*return*/, controlId];
        }
    });
}); };
exports.create = create;
var makeUpdateMapFromDelete = function (controlId) { return __awaiter(void 0, void 0, void 0, function () {
    var controlData, cycleUpdateMap, processUpdateMap, riskUpdateMap, staffUpdateMap, departmentUpdateMap;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, get(controlId)
                // CYCLE 업데이트 객체
            ];
            case 1:
                controlData = _a.sent();
                cycleUpdateMap = new UpdateContainer_1.default();
                cycleUpdateMap.del(controlData.cycleIds[0], 'controlIds', controlId);
                processUpdateMap = new UpdateContainer_1.default();
                processUpdateMap.dels(controlData.processIds, 'controlIds', controlId);
                riskUpdateMap = new UpdateContainer_1.default();
                riskUpdateMap.dels(controlData.riskIds, 'controlIds', controlId);
                staffUpdateMap = new UpdateContainer_1.default();
                staffUpdateMap.del(controlData.owner, 'controlIds', controlId);
                departmentUpdateMap = new UpdateContainer_1.default();
                departmentUpdateMap.del(controlData.department, 'controlIds', controlId);
                return [2 /*return*/, {
                        cycleUpdateMap: cycleUpdateMap,
                        processUpdateMap: processUpdateMap,
                        riskUpdateMap: riskUpdateMap,
                        staffUpdateMap: staffUpdateMap,
                        departmentUpdateMap: departmentUpdateMap
                    }];
        }
    });
}); };
var remove = function (controlId) { return __awaiter(void 0, void 0, void 0, function () {
    var updateResult, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, makeUpdateMapFromDelete(controlId)];
            case 1:
                updateResult = _a.sent();
                docRef = firebase.dbService.collection(RCMUtils_1.CONTROL_COLLECTION_NAME).doc(controlId);
                return [4 /*yield*/, docRef.delete()];
            case 2:
                _a.sent();
                return [4 /*yield*/, CycleManager.updateMaps(updateResult.cycleUpdateMap)];
            case 3:
                _a.sent();
                return [4 /*yield*/, ProcessManager.updateMaps(updateResult.processUpdateMap)];
            case 4:
                _a.sent();
                return [4 /*yield*/, RiskManager.updateMaps(updateResult.riskUpdateMap)];
            case 5:
                _a.sent();
                return [4 /*yield*/, StaffManager.updateMaps(updateResult.staffUpdateMap)];
            case 6:
                _a.sent();
                return [4 /*yield*/, DepartmentManager.updateMaps(updateResult.departmentUpdateMap)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.remove = remove;
var makeUpdateMapWithRisk = function (controlId, riskId) { return __awaiter(void 0, void 0, void 0, function () {
    var controlData, riskData, newProcessIdList, prevRiskId, prevProcessIdList, riskUpdateMap, processUpdateMap;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, get(controlId)];
            case 1:
                controlData = _a.sent();
                newProcessIdList = [];
                if (!(riskId !== '')) return [3 /*break*/, 3];
                return [4 /*yield*/, RiskManager.get(riskId)];
            case 2:
                riskData = _a.sent();
                newProcessIdList = riskData.processIds;
                _a.label = 3;
            case 3:
                prevRiskId = controlData.riskNumber;
                prevProcessIdList = controlData.processIds;
                riskUpdateMap = new UpdateContainer_1.default();
                riskUpdateMap.add(riskId, 'controlIds', controlId);
                riskUpdateMap.del(prevRiskId, 'controlIds', controlId);
                processUpdateMap = new UpdateContainer_1.default();
                processUpdateMap.adds(newProcessIdList, 'controlIds', controlId);
                processUpdateMap.dels(prevProcessIdList, 'controlIds', controlId);
                return [2 /*return*/, { processUpdateMap: processUpdateMap, riskUpdateMap: riskUpdateMap }];
        }
    });
}); };
var updateMapWithRisk = function (controlId, riskId) { return __awaiter(void 0, void 0, void 0, function () {
    var riskNumber, riskName, riskIds, processIds, processCode, riskData, updateResult, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                riskNumber = '';
                riskName = '';
                riskIds = [];
                processIds = [] // CONTROL 은 PROCESS 와 연결될 수 있는 이유는 연결된 RISK 때문이다.
                ;
                processCode = '' // CONTROL 은 PROCESS 와 연결될 수 있는 이유는 연결된 RISK 때문이다.
                ;
                if (!(riskId !== '')) return [3 /*break*/, 2];
                return [4 /*yield*/, RiskManager.get(riskId)];
            case 1:
                riskData = _a.sent();
                riskNumber = riskData.id;
                riskName = riskData.name;
                riskIds = [riskData.id];
                processIds = riskData.processIds;
                processCode = processIds[0];
                _a.label = 2;
            case 2: return [4 /*yield*/, makeUpdateMapWithRisk(controlId, riskId)];
            case 3:
                updateResult = _a.sent();
                docRef = firebase.dbService.collection(RCMUtils_1.CONTROL_COLLECTION_NAME).doc(controlId);
                return [4 /*yield*/, docRef.update({
                        riskNumber: riskNumber,
                        riskName: riskName,
                        riskIds: riskIds,
                        processIds: processIds,
                        processCode: processCode
                    })];
            case 4:
                _a.sent();
                return [4 /*yield*/, ProcessManager.updateMaps(updateResult.processUpdateMap)];
            case 5:
                _a.sent();
                return [4 /*yield*/, RiskManager.updateMaps(updateResult.riskUpdateMap)];
            case 6:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.updateMapWithRisk = updateMapWithRisk;
var makeUpdateMapWithStaff = function (controlId, staffId) { return __awaiter(void 0, void 0, void 0, function () {
    var controlData, staffData, staffUpdateMap, departmentUpdateMap;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, get(controlId)];
            case 1:
                controlData = _a.sent();
                return [4 /*yield*/, StaffManager.get(staffId)
                    // STAFF 업데이트 객체
                ];
            case 2:
                staffData = _a.sent();
                staffUpdateMap = new UpdateContainer_1.default();
                staffUpdateMap.add(staffId, 'controlIds', controlId);
                if (controlData.owner !== staffId) {
                    // NOTE: 컨트롤을 생성할 때는 해당 controlData.owner 와 staffId 가 동일하다
                    staffUpdateMap.del(controlData.owner, 'controlIds', controlId); // Prev staff
                }
                departmentUpdateMap = new UpdateContainer_1.default();
                departmentUpdateMap.add(staffData.departmentName, 'controlIds', controlId);
                if (controlData.department !== staffData.departmentName) {
                    departmentUpdateMap.del(controlData.department, 'controlIds', controlId); // Prev department
                }
                return [2 /*return*/, { staffUpdateMap: staffUpdateMap, departmentUpdateMap: departmentUpdateMap }];
        }
    });
}); };
var updateMapWithStaff = function (controlId, staffId) { return __awaiter(void 0, void 0, void 0, function () {
    var staffData, departmentId, controlData, updateResult, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, StaffManager.get(staffId)];
            case 1:
                staffData = _a.sent();
                departmentId = staffData.departmentName;
                return [4 /*yield*/, get(controlId)];
            case 2:
                controlData = _a.sent();
                return [4 /*yield*/, makeUpdateMapWithStaff(controlId, staffId)];
            case 3:
                updateResult = _a.sent();
                docRef = firebase.dbService.collection(RCMUtils_1.CONTROL_COLLECTION_NAME).doc(controlId);
                return [4 /*yield*/, docRef.update({
                        owner: staffId,
                        staffIds: [staffId],
                        department: departmentId,
                        departmentIds: [departmentId]
                    })
                    // TODO: 평가보고서
                    // CONTROL - STAFF 맵핑을 하면 해당 내용을 바탕으로 Template 을 업데이트 해야한다
                ];
            case 4:
                _a.sent();
                // TODO: 평가보고서
                // CONTROL - STAFF 맵핑을 하면 해당 내용을 바탕으로 Template 을 업데이트 해야한다
                controlData.owner = staffId;
                controlData.department = departmentId;
                return [4 /*yield*/, TemplateUpdater.updateTemplate('operation', controlId, controlData)];
            case 5:
                _a.sent();
                return [4 /*yield*/, StaffManager.updateMaps(updateResult.staffUpdateMap)];
            case 6:
                _a.sent();
                return [4 /*yield*/, DepartmentManager.updateMaps(updateResult.departmentUpdateMap)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.updateMapWithStaff = updateMapWithStaff;
// export const controlListMappingWithAdmin = async (staffId, adminId) => {
var updateMapWithAdmin = function (staffId, adminId) { return __awaiter(void 0, void 0, void 0, function () {
    var adminData, adminDepartmentId, staffData, departmentId, controlIds, departmentUpdateMap;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, StaffManager.get(adminId)];
            case 1:
                adminData = _a.sent();
                adminDepartmentId = adminData.departmentName;
                return [4 /*yield*/, StaffManager.get(staffId)];
            case 2:
                staffData = _a.sent();
                departmentId = staffData.departmentName;
                controlIds = staffData.controlIds;
                return [4 /*yield*/, Promise.all(controlIds.map(function (controlId) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, firebase.dbService
                                        .collection(RCMUtils_1.CONTROL_COLLECTION_NAME)
                                        .doc(controlId)
                                        .update({
                                        owner: adminId,
                                        staffIds: [adminId],
                                        department: adminDepartmentId,
                                        departmentIds: [adminDepartmentId]
                                    })];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); }))];
            case 3:
                _a.sent();
                return [4 /*yield*/, firebase.dbService.collection('STAFF').doc(staffId).update({
                        controlIds: []
                    })];
            case 4:
                _a.sent();
                return [4 /*yield*/, firebase.dbService.collection('STAFF').doc(adminId).update({
                        controlIds: controlIds
                    })];
            case 5:
                _a.sent();
                departmentUpdateMap = new UpdateContainer_1.default();
                lodash_1.default.forEach(controlIds, function (id) {
                    departmentUpdateMap.del(departmentId, 'controlIds', id);
                    departmentUpdateMap.add(adminDepartmentId, 'controlIds', id);
                });
                DepartmentManager.updateMaps(departmentUpdateMap);
                return [2 /*return*/];
        }
    });
}); };
exports.updateMapWithAdmin = updateMapWithAdmin;
//# sourceMappingURL=ControlManager.js.map